// Layout optimizado para móviles
// Incluye navbar, sidebar y footer consistentes
// Maneja la actualización de ubicación del usuario con Explorer

import React, { memo } from 'react';
import Navbar from '../Navigation/Navbar';
import NavbarBottom from '../Navigation/NavbarBottom';
import Alert from '../UI/Alert';
import BannerPromotional from '../ecommerce/BannerPromotional';

/**
 * Componente MobileLayout
 * 
 * Layout optimizado para dispositivos móviles
 * Estructura: Navbar (top) + Content (center) + NavbarBottom (bottom)
 * Sin sidebar para maximizar espacio en pantallas pequeñas
 * 
 * @param {Object} props - Props del componente
 * @param {React.ReactNode} props.children - Contenido de la página
 * @param {Object} props.locationData - Datos de ubicación (compartido desde MainLayout)
 * @param {Function} props.requestLocationPermission - Función para solicitar permisos (compartido desde MainLayout)
 * @param {boolean} props.showPermissionAlert - Estado de alerta de permisos (compartido desde MainLayout)
 * @param {boolean} props.loading - Estado de carga (compartido desde MainLayout)
 * @param {Function} props.onDismissAlert - Función para cerrar alerta (compartido desde MainLayout)
 * @param {boolean} props.hideNavbar - Ocultar Navbar superior (default: false)
 * @param {boolean} props.hideNavbarBottom - Ocultar NavbarBottom inferior (default: false)
 */
const MobileLayout = ({ 
  children, 
  locationData, 
  requestLocationPermission, 
  showPermissionAlert, 
  loading,
  onDismissAlert,
  hideNavbar = false,
  hideNavbarBottom = false
}) => {
  return (
    <div className="min-h-screen bg-neutral-900 flex flex-col">

      {/* Alerta de permisos de geolocalización - Mobile optimizado */}
      {showPermissionAlert && (
        <div className="fixed top-2 left-2 right-2 z-50">
          <Alert
            type="warning"
            title="Permiso de ubicación"
            message="Necesitamos tu ubicación para mostrar usuarios cercanos."
            dismissible={true}
            onDismiss={onDismissAlert}
          >
            <button
              onClick={requestLocationPermission}
              disabled={loading}
              className="mt-3 w-full px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm font-medium disabled:opacity-50"
            >
              {loading ? 'Obteniendo...' : 'Habilitar'}
            </button>
          </Alert>
        </div>
      )}

      {/* {!hideNavbar && <Navbar />} */}

      {/* Área de contenido - Mobile sin padding extra para maximizar espacio */}
      <main className="flex-1">
        {children}
      </main>

      {!hideNavbarBottom && <NavbarBottom />}

      <div className='fixed bottom-[4.5rem] left-0 right-0 z-10'>
        <BannerPromotional />
      </div>

    </div>
  );
};

// Memoizar MobileLayout para prevenir re-renders innecesarios
export default memo(MobileLayout, (prevProps, nextProps) => {
  return prevProps.children === nextProps.children &&
         prevProps.showPermissionAlert === nextProps.showPermissionAlert &&
         prevProps.loading === nextProps.loading;
});
